

// Screens
import Blank from "./Screens/Blank.js";
import Home from "./Screens/Home/Main.js";
import Order from "./Screens/Order/Main.js";

import OrderHotelSearchResult from "./Screens/Order/hotelSearchResult.js";
import OrderHotelHotelView from "./Screens/Order/hotelDetails.js";

import OrderHotelBooking from "./Screens/Order/hotelBooking.js";
import OrderHotelBookingConfirm from "./Screens/Order/hotelBookingConfirm.js"; 
import OrderHotelBookingPayment from "./Screens/Order/hotelBookingPayment.js";

import UserPasswordSetup from "./Screens/User/PasswordSetup.js";

 
import Admin from "./Screens/Admin/Main.js";
import AdminReservations from "./Screens/Admin/Reservations.js";
import AdminAgencies from "./Screens/Admin/Agencies.js";
import AdminAgenciesApproval from "./Screens/Admin/AgenciesApproval.js";

import AdminUserProfile from "./Screens/Admin/UserProfile.js";
import AdminAgencyProfile from "./Screens/Admin/AgencyProfile.js";

import AdminDashboard from "./Screens/Admin/Dashboard.js";
import AdminUsers from "./Screens/Admin/Users.js";
import AdminMasterUsers from "./Screens/Admin/MasterUsers.js";

import AdminCustomers from "./Screens/Admin/Customers.js";
import AdminReports from "./Screens/Admin/Reports.js";
import AdminConfigurations from "./Screens/Admin/Configurations.js";

var dashRoutes = [
  {
    path: "/home",
    name: "Início",
    component: Home,
    secured: false
  },  
  {
    path: "/order",
    name: "Defina como será a estadia",
    component: Order,
    secured: true
  },
  {
    path: "/order/hotel/searchResult",
    name: "Compra de Hospedagem > Buscando",
    component: OrderHotelSearchResult,
    secured: true
  }, 
  {
    path: "/order/hotel/view/:id",
    name: "Compra de Hospedagem > Visualizando Hotel",
    component: OrderHotelHotelView,
    secured: true
  },    
  {
    path: "/order/hotel/booking",
    name: "Compra de Hospedagem > Reservando Hotel",
    component: OrderHotelBooking,
    secured: true
  },    
  {
    path: "/order/hotel/booking/confirm",
    name: "Compra de Hospedagem > Confirmação de Reserva",
    component: OrderHotelBookingConfirm,
    secured: true
  }, 
  {
    path: "/order/hotel/booking/payment",
    name: "Compra de Hospedagem > Pagamento",
    component: OrderHotelBookingPayment,
    secured: true
  }, 
  { 
    path: "/admin",
    name: "Área administrativa",
    component: Admin,
    secured: true
  },
  { 
    path: "/admin/dashboard",
    name: "Área administrativa - Dashboard",
    component: AdminDashboard,
    secured: true
  },  
  { 
    path: "/admin/agencies",
    name: "Área administrativa - Agências",
    component: AdminAgencies,
    secured: true
  },  
  { 
    path: "/admin/agenciesApproval",
    name: "Área administrativa - Agências aguardando aprovação",
    component: AdminAgenciesApproval,
    secured: true
  },  
  { 
    path: "/admin/userProfile",
    name: "Área administrativa - Perfil do usuário",
    component: AdminUserProfile,
    secured: true
  },
  { 
    path: "/admin/agencyProfile",
    name: "Área administrativa - Perfil da Agência",
    component: AdminAgencyProfile,
    secured: true
  },  
  { 
    path: "/admin/users",
    name: "Área administrativa - Usuários da Agência",
    component: AdminUsers,
    secured: true
  },    
  { 
      path: "/admin/masterUsers",
      name: "Área administrativa - Usuários Agência Master",
      component: AdminMasterUsers,
      secured: true
  },   
{ 
    path: "/admin/customers",
    name: "Área administrativa - Clientes da Agência",
    component: AdminCustomers,
    secured: true
  },      
  { 
    path: "/admin/reservations",
    name: "Área administrativa - Reservas",
    component: AdminReservations,
    secured: true
  },    
  { 
    path: "/admin/reports",
    name: "Área administrativa - Relatórios",
    component: AdminReports,
    secured: true
  },      
  { 
    path: "/admin/configurations",
    name: "Área administrativa - Configurações",
    component: AdminConfigurations,
    secured: true
  },  
  {
    path: "/usuario/definir-senha/:token",
    name: "Definir Senha",
    component: UserPasswordSetup,
    secured: false
  }
];
export default dashRoutes;
